import { Brain } from "lucide-react";
import { cdnUrl, cn } from "@/lib/utils";

const MARCUS_STATIC_AVATAR_SRC = cdnUrl("/Marcus-ecommerce.jpg");

interface CompanionDockAvatarPersona {
  humanName: string;
}

function isMarcusPersona(persona?: CompanionDockAvatarPersona | null) {
  return persona?.humanName.trim().toLowerCase() === "marcus";
}

export function CompanionDockAvatarMedia({
  persona,
  mediaClassName,
  iconClassName,
}: {
  persona?: CompanionDockAvatarPersona;
  mediaClassName?: string;
  iconClassName?: string;
}) {
  const isMarcus = isMarcusPersona(persona);

  if (isMarcus) {
    const mediaClasses = cn("absolute inset-0 h-full w-full object-cover", mediaClassName);
    return (
      <>
        <img
          src={MARCUS_STATIC_AVATAR_SRC}
          alt=""
          loading="eager"
          decoding="async"
          className={mediaClasses}
          style={{ objectPosition: "center 25%" }}
        />
        <span
          aria-hidden="true"
          className="absolute inset-0 bg-[radial-gradient(circle,transparent_56%,rgba(0,0,0,0.2)_100%)]"
        />
      </>
    );
  }

  return (
    <>
      <span
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(circle_at_30%_18%,hsl(var(--primary)/0.18),transparent_54%)]"
      />
      <Brain className={cn("relative z-10 text-foreground/70", iconClassName)} />
    </>
  );
}
